import { SimpleGrid } from '@mantine/core';
import type { DeliveryImpactMetrics } from '../../../api/agent-miner-client/agent-miner-client.type';
import { METRIC_CARDS } from './delivery-impact.helpers';
import { MetricComparisonCard } from './metric-comparison-card';

type Props = {
  metrics: DeliveryImpactMetrics | undefined;
};

/**
 * The Delivery Impact tiles view: the six AI-vs-baseline comparison cards in
 * a responsive grid (3×2 on wide screens).
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element} The comparison card grid
 */
export const ComparisonCards = ({ metrics }: Props) => (
  <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing={16} data-testid="delivery-impact-cards">
    {METRIC_CARDS.map((config) => (
      <MetricComparisonCard key={config.key} config={config} metric={metrics?.[config.key]} />
    ))}
  </SimpleGrid>
);
